import React from "react";
import { Navigate } from "react-router-dom";

export default class SeeAllBtn extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="see-all">
        {this.state.redirect && (
          <Navigate
            to={{
              pathname: this.state.pathname,
              state: this.state.state
            }}
          />
        )}
        <span className="see-all-text" onClick={() => this.props.link()}>
          See All
        </span>
        <span className="see-all-btn" onClick={() => this.props.link()}>
          +
        </span>
      </div>
    );
  }
}
